import { render, staticRenderFns } from "./CreateMundialForm.vue?vue&type=template&id=fa8f5206&"
import script from "./CreateMundialForm.vue?vue&type=script&lang=js&"
export * from "./CreateMundialForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports